import type { ReactNode } from 'react';

import { match } from 'ts-pattern';

import { Icon } from '~/components';
import { Field } from '~/components/Form';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import { bulletStyle, hintStyle, iconStyle } from './PasswordRequirementHint.css';

type Props = {
  children: ReactNode;
  showInvalid: boolean;
  valid: boolean;
};

export const PasswordRequirementHint = ({ children, showInvalid, valid }: Props) => {
  const status = valid ? 'success' : showInvalid ? 'danger' : 'neutral';

  return (
    <Field.Description
      className={clsx(hintStyle, status === 'success' && statusColorThemes.success, status === 'danger' && statusColorThemes.danger)}
    >
      <span className={iconStyle}>
        {match(status)
          .with('success', () => <Icon name="Check" size={16} />)
          .with('danger', () => <Icon name="CloseSmall" size={16} />)
          .otherwise(() => (
            <span className={bulletStyle} />
          ))}
      </span>

      {children}
    </Field.Description>
  );
};
